<header id="global-header" [ngClass]="[headerTheme]">
  <div *ngIf="header" class="header-wrapper">
    <app-go-back-button
      *ngIf="goBackRoute"
      [goBackRoute]="goBackRoute"
      class="go-back-action"
      e2eId="global-header-go-back-action"
    ></app-go-back-button>

    <h2 class="header" data-e2e-id="global-header-title">
      {{ header }}
    </h2>

    <app-icon
      *ngIf="headerIcon"
      [icon]="headerIcon"
      class="header-icon"
      (click)="onClickHeaderIcon.emit()"
    >
    </app-icon>
  </div>

  <div class="center-slot-wrapper">
    <div class="center-slot">
      <ng-content select="center-slot"></ng-content>
    </div>
  </div>

  <div class="right-slot-wrapper">
    <ng-content select="right-slot"></ng-content>
  </div>
</header>

<app-global-banner *ngIf="!disableGlobalBanner"></app-global-banner>
